<template>
  <div class="carousel">
    <i :style="{fontSize:iconSize}" class="el-icon-arrow-left iconLeft" @click="clickLeft"></i>
    <div class="carouselVessel" :style="{width:width+'px',height:height+'px'}">
      <ul class="carouselUl" :style="{left:left + 'px'}">
        <li v-if="deviceStatus === '2'" class="carouselLi" :style="{width:width+'px',height:height+'px'}">
          <p>暂无上报虫害图片</p>
        </li>
        <li class="carouselLi" :style="{width:width+'px',height:height+'px'}" v-for="(item,index) in imgList" :key="index">
          <img v-if="item.imageResult" :src="item.imageResult">
          <div v-else class="imageError">暂无数据</div>
          <span class="time">{{time}}</span>
        </li>
      </ul>
    </div>
    <i :style="{fontSize:iconSize}" class="el-icon-arrow-right iconRight" @click="clickRight"></i>
  </div>
</template>

<script>
export default {
  name: 'Carousel',
  data () {
    return {
      left: 0,
      time: '',
      size: 10
    }
  },
  props: {
    imgList: {
      type: Array,
      default: () => []
    },
    deviceStatus: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: 0
    },
    iconSize: {
      type: String,
      default: '10px'
    }
  },
  created () {
  },
  watch: {
    imgList (list) {
      if (this.deviceStatus === '2') {
        this.$emit('imgData', [])
        this.time = ''
      } else if (list && list.length > 0) {
        this.$emit('imgData', this.imgList[0].insectResultList)
        this.time = list[0].collectTime
      }
    }
  },
  methods: {
    clickLeft () {
      if (this.left < 0) {
        this.left += this.width
        this.onData()
      }
    },
    clickRight () {
      const ulWidth = (this.imgList.length - (this.deviceStatus === '2' ? 0 : 1)) * this.width * -1
      if (this.left > ulWidth) {
        this.left -= this.width
        this.onData()
      }
    },
    onData () {
      const data = this.imgList[Math.abs(this.left / this.width) - (this.deviceStatus === '2' ? 1 : 0)]
      this.time = data ? data.collectTime : ''
      this.$emit('imgData', data ? data.insectResultList : [])
    }
  }
}
</script>

<style scoped lang='scss'>
.carousel{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px auto;
  .iconLeft{
    color: rgba(140, 140, 140, 1);
    font-weight: bold;
    cursor: pointer;
  }
  .iconRight{
    color: rgba(140, 140, 140, 1);
    font-weight: bold;
    cursor: pointer;
  }
  .iconLeft:hover{
    color: rgba(140, 140, 140, 0.5);
  }
  .iconRight:hover{
    color: rgba(140, 140, 140, 0.5);
  }
  .carouselVessel{
    margin: 0 auto;
    overflow: hidden;
    position: relative;
    .carouselUl{
      position: absolute;
      left: 0;
      top: 0;
      display: flex;
      justify-content: space-between;
      transition: all 0.5s;
      .carouselLi{
        position: relative;
        list-style-type:none;
        background-color: rgba(240, 242, 245, 1);
        font-size: 14px;
        color:rgba(147, 151, 160, 1);
        text-align:center;
        line-height: 176px;
        img{
          width: 100%;
          height: 100%;
        }
        .time{
          position: absolute;
          right: 0;
          bottom: 8px;
          width: 138px;
          height: 20px;
          text-align: center;
          font-size: 12px;
          line-height: 20px;
          color: rgba(255, 255, 255, 1);
          background-color: rgba(25, 212, 121, 0.8);
          border-radius: 2px 0px 0px 2px;
        }
        .imageError{
          color:#909399;
          background-color:#f5f7fa;
          text-align:center;
          line-height: 178px;
        }
      }
    }
  }
}
</style>
